module.exports = __webpack_public_path__ + "assets/img/new-24-logo.ec9f217f.jpg";